export default "__VITE_ASSET__DqS1Q7ZM__"